import actionTypes from "../../constants/action-types";

const questionnaireReviewReducer = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.questionnaireReview.SUBMIT_REVIEW_SUCCESS: {
      return {
        ...state,
        error: null,
        questionnaireResponse: action.questions

      }
    }
    case actionTypes.questionnaireReview.SUBMIT_REVIEW_FAILURE: {
      return {
        ...state,
        error: action.error,
      }
    }
    case actionTypes.questionnaireReview.CLEAR_QUESTIONNAIR_RESPONSE_LIST: {
      return {
        ...state,
        questionnaireResponse: []
      }
    }
    default:
      return state;
  }
};

export default questionnaireReviewReducer;